<template>
  <a-select v-model:value="localValue" :placeholder="placeholder" style="width: 100%">
    <a-select-option v-for="opt in options" :value="opt.value" :key="opt.value"> {{ opt.name }} </a-select-option>
  </a-select>
</template>

<script>
import mixin from '../mixin/AExtStringMixin'


import DanWeiJiBie from './LocalDic/DanWeiJiBie'
import DanWeiXingZhi from './LocalDic/DanWeiXingZhi'
import DoubleCheckResult from './LocalDic/DoubleCheckResult'
import DoubleCheckStatus from './LocalDic/DoubleCheckStatus'
import GuiMoLeiXing from './LocalDic/GuiMoLeiXing'
import HangYe from './LocalDic/HangYe'
import MonitCheckResult from './LocalDic/MonitCheckResult'
import MonitLink from './LocalDic/MonitLink'
import MonitPlanLevel from './LocalDic/MonitPlanLevel'
import MonitPlanStatus from './LocalDic/MonitPlanStatus'
import MonitPlanType from './LocalDic/MonitPlanType'
import MonitProjectStatus from './LocalDic/MonitProjectStatus'
import MonitProjectType from './LocalDic/MonitProjectType'
import MonitTaskCheckStatus from './LocalDic/MonitTaskCheckStatus'
import MonitTaskPickCheckStatus from './LocalDic/MonitTaskPickCheckStatus'
import MonitTaskPickStatus from './LocalDic/MonitTaskPickStatus'
import MonitTaskStatus from './LocalDic/MonitTaskStatus'
import OfferLevel from './LocalDic/OfferLevel'
import SendMsgDays from './LocalDic/SendMsgDays'
import SendMsgTime from './LocalDic/SendMsgTime'
import Sex from './LocalDic/Sex'
import StdAvailableStatus from './LocalDic/StdAvailableStatus'
import StdPublishStatus from './LocalDic/StdPublishStatus'
import Unit from './LocalDic/Unit'

export default {
    name: "index",
    mixins:[mixin],
    props:{
        dicKey:{
            type:String,
            default:''
        }
    },
    data() {
        return {
            options:[],
            localValue: ''
        }
    },
    created(){
        this.init()
    },
    methods:{
        init(){
          switch (this.dicKey) {
              case 'DanWeiJiBie':
                  this.options=DanWeiJiBie;
                  break;
              case 'DanWeiXingZhi':
                  this.options=DanWeiXingZhi;
                  break;
              case 'DoubleCheckResult':
                  this.options=DoubleCheckResult;
                  break;
              case 'DoubleCheckStatus':
                  this.options=DoubleCheckStatus;
                  break;
              case 'GuiMoLeiXing':
                  this.options=GuiMoLeiXing;
                  break;
              case 'HangYe':
                  this.options=HangYe;
                  break;
              case 'MonitCheckResult':
                  this.options=MonitCheckResult;
                  break;
              case 'MonitLink':
                  this.options=MonitLink;
                  break;
              case 'MonitPlanLevel':
                  this.options=MonitPlanLevel;
                  break;
              case 'MonitPlanStatus':
                  this.options=MonitPlanStatus;
                  break;
              case 'MonitPlanType':
                  this.options=MonitPlanType;
                  break;
              case 'MonitProjectStatus':
                  this.options=MonitProjectStatus;
                  break;
              case 'MonitProjectType':
                  this.options=MonitProjectType;
                  break;
              case 'MonitTaskCheckStatus':
                  this.options=MonitTaskCheckStatus;
                  break;
              case 'MonitTaskPickCheckStatus':
                  this.options=MonitTaskPickCheckStatus;
                  break;
              case 'MonitTaskPickStatus':
                  this.options=MonitTaskPickStatus;
                  break;
              case 'MonitTaskStatus':
                  this.options=MonitTaskStatus;
                  break;
              case 'OfferLevel':
                  this.options=OfferLevel;
                  break;
              case 'SendMsgDays':
                  this.options=SendMsgDays;
                  break;
              case 'SendMsgTime':
                  this.options=SendMsgTime;
                  break;
              case 'Sex':
                  this.options=Sex;
                  break;
              case 'StdAvailableStatus':
                  this.options=StdAvailableStatus;
                  break;
              case 'StdPublishStatus':
                  this.options=StdPublishStatus;
                  break;
              case 'Unit':
                  this.options=Unit;
                  break;
              default:
                  this.options=[]
          }
        }
    }

}
</script>

<style scoped>

</style>